const baseConfig = require('../../../tinymce.config')

window.tinymceConfig = function (customConfig) {
    return Object.assign(baseConfig, customConfig)
}